
      import { createElement } from 'react';
      import { createRoot } from 'react-dom/client';
      import { Application } from '@/client';

      const root = createRoot(document.getElementById('profai'));
      root.render(createElement(Application, null, null));
    